<template>
  <calm-page extra-class="wht" :eyebrow="$t('menu.wht')" :title="$t('menu.wht')">
    <template slot="actions">
      <calm-button variant="primary" @click="handleCreate()">
        <i class="fas fa-plus mr-1"></i> {{ $t("new") }}
      </calm-button>
    </template>

    <!-- ═══════════════ SEARCH BAR ═══════════════ -->
    <calm-filter-bar :hide-actions="true">
      <calm-field :label="$t('lmg.start_date')">
        <flat-picker
          slot-scope="{ focus, blur }"
          @on-open="focus"
          @on-close="blur"
          :config="{ allowInput: true }"
          :rules="{ required: true }"
          class="ed calm-cal"
          v-model="params.start_date"
        >
        </flat-picker>
      </calm-field>

      <calm-field :label="$t('lmg.end_date')">
        <flat-picker
          slot-scope="{ focus, blur }"
          @on-open="focus"
          @on-close="blur"
          :config="{ allowInput: true }"
          :rules="{ required: true }"
          class="ed calm-cal"
          v-model="params.end_date"
        >
        </flat-picker>
      </calm-field>

      <calm-field :label="$t('lmg.owner_person')">
        <el-select
          v-model="params.owner_person_id"
          :placeholder="$t('lmg.owner_person')"
          filterable
        >
          <el-option
            v-for="option in tablePerson"
            :key="option.ID"
            :label="option.FName + ' ' + option.LName"
            :value="option.ID"
          >
          </el-option>
        </el-select>
      </calm-field>

      <calm-field :label="$t('lmg.book_id')">
        <input
          v-model="params.book_id"
          type="text"
          class="ed"
          :placeholder="$t('lmg.book_id')"
        />
      </calm-field>

      <calm-field :label="$t('lmg.number_id')">
        <input
          v-model="params.number_id"
          type="text"
          class="ed"
          :placeholder="$t('lmg.number_id')"
        />
      </calm-field>

      <calm-field>
        <calm-button
          variant="primary"
          :loading="isLoading"
          @click="listData(paramsSearch)"
        >
          <i class="fas fa-search mr-1"></i> {{ $t("search") }}
        </calm-button>
      </calm-field>
    </calm-filter-bar>

    <!-- ═══════════════ TABLE (skin the existing el-table, §11) ═══════════════ -->
    <calm-table
      :total="total"
      :from="from"
      :to="to"
      :per-page.sync="pagination.perPage"
      :current-page.sync="pagination.currentPage"
      :per-page-options="pagination.perPageOptions"
      :per-page-label="$t('per_page') !== 'per_page' ? $t('per_page') : 'ต่อหน้า'"
      :count-label="$t('data')"
      :to-label="$t('to')"
      :of-label="$t('of')"
      :empty-title="$t('no_data') !== 'no_data' ? $t('no_data') : 'ไม่พบข้อมูล'"
    >
      <template slot="toolbar">
        <input
          v-model="searchQuery"
          type="text"
          class="ed wht__search"
          :placeholder="$t('search')"
        />
      </template>

      <el-table
        :data="queriedData"
        row-key="id"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
        @selection-change="selectionChange"
      >
        <!-- Agent -->
        <el-table-column :label="$t('lmg.person')">
          <div slot-scope="{ row }" class="d-flex">
            {{ row.owner_person_fname }} {{ row.owner_person_lname }}
          </div>
        </el-table-column>

        <!-- Book -->
        <el-table-column :label="$t('lmg.book_id')">
          <div slot-scope="{ row }" class="d-flex">
            {{ row.book_id }}
          </div>
        </el-table-column>

        <!-- number -->
        <el-table-column :label="$t('lmg.number_id')">
          <div slot-scope="{ row }" class="d-flex">
            {{ row.number_id }}
          </div>
        </el-table-column>

        <!-- amount -->
        <el-table-column :label="$t('lmg.amount')">
          <div slot-scope="{ row }" class="d-flex">
            <span class="wht__amount">{{ row.sum_commission }}</span>
          </div>
        </el-table-column>

        <el-table-column :label="$t('lmg.created')">
          <div slot-scope="{ row }" class="d-flex">
            {{ row.created_at_show }}
          </div>
        </el-table-column>

        <el-table-column
          min-width="200px"
          align="right"
          :label="$t('actions')"
        >
          <div slot-scope="{ row }" class="wht__rowact">
            <calm-button
              variant="ghost"
              size="sm"
              icon-only
              @click="handleDetail(row)"
            >
              <i class="fa fa-file"></i>
            </calm-button>

            <calm-button
              variant="ghost"
              size="sm"
              icon-only
              @click="handleExport(row)"
            >
              <i class="fa fa-download"></i>
            </calm-button>
          </div>
        </el-table-column>
      </el-table>
    </calm-table>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary modal-lg">
      <div class="row">
        <div class="col col-lg-3">
          <h1>{{ $t("lmg.wht") }}</h1>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.owner_person')"
            :name="$t('lmg.owner_person')"
            rules="required"
            input-classes="form-control-alternative new-event--title"
          >
            <el-select
              v-model="params.owner_person_id"
              :placeholder="$t('lmg.owner_person')"
              filterable
              @change="SearchTransaction()"
            >
              <el-option
                v-for="option in tablePerson"
                :key="option.ID"
                :label="option.FName + ' ' + option.LName"
                :value="option.ID"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>

		<div class="col-lg-2">
			<base-input
			:label="$t('lmg.per_page')">
			<el-select
                class="select-primary pagination-select"
                v-model="pagination2.perPage"
                title="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination2.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
			</base-input>
		</div>
      </div>

      <!-- ownerpersonid -->

      <calm-table
        :total="total2"
        :from="from2"
        :to="to2"
        :per-page.sync="pagination2.perPage"
        :current-page.sync="pagination2.currentPage"
        :per-page-options="pagination2.perPageOptions"
        :per-page-label="$t('per_page') !== 'per_page' ? $t('per_page') : 'ต่อหน้า'"
        :count-label="$t('data')"
        :to-label="$t('to')"
        :of-label="$t('of')"
        :empty-title="$t('no_data') !== 'no_data' ? $t('no_data') : 'ไม่พบข้อมูล'"
      >
        <el-table
          :data="queriedData2"
          row-key="id"
          header-row-class-name="thead-light"
          @selection-change="selectionChange2"
        >
          <el-table-column type="selection" />
          <!-- Agent -->

          <el-table-column :label="$t('lmg.customer')" min-width="200">
            <template slot-scope="{ row }">
              {{ row.CustomerFname }} {{ row.CustomerLname }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('lmg.policy_number')" min-width="200">
            <template slot-scope="{ row }">
              {{ row.PolicyNumber }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('lmg.protection_date')" min-width="200">
            <template slot-scope="{ row }">
              {{ row.StartDateShow }} - {{ row.EndDateShow }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('lmg.amount')" min-width="150">
            <template slot-scope="{ row }">
              <span v-if="row.MoreDiscount > 0" class="text-red">{{
                FormatCurrency(row.Amount)
              }}</span>
              <span v-else>{{ FormatCurrency(row.Amount) }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('lmg.discount')" min-width="150">
            <template slot-scope="{ row }">
              {{ FormatCurrency(row.CommissionAmount) }}
            </template>
          </el-table-column>
        </el-table>
      </calm-table>

      <div class="row" slot="footer">
        <div class="col wht__modal-actions">
          <calm-button
            variant="primary"
            native-type="submit"
            @click="onCreate()"
            v-if="selectedRows2.length > 0"
          >
            {{ $t("save") }}
          </calm-button>

          <calm-button
            variant="ghost"
            @click="showAddModal = false"
          >
            {{ $t("close") }}
          </calm-button>
        </div>
      </div>
    </modal>

	 <modal :show.sync="showTransModal" modal-classes="modal-secondary modal-lg">
      <div class="row">
        <div class="col col-lg-3">
          <h1>{{ $t("menu.trans") }}</h1>
        </div>
      </div>

      <!-- ownerpersonid -->

      <calm-table
        :total="total2"
        :from="from2"
        :to="to2"
        :per-page.sync="pagination2.perPage"
        :current-page.sync="pagination2.currentPage"
        :per-page-options="pagination2.perPageOptions"
        :per-page-label="$t('per_page') !== 'per_page' ? $t('per_page') : 'ต่อหน้า'"
        :count-label="$t('data')"
        :to-label="$t('to')"
        :of-label="$t('of')"
        :empty-title="$t('no_data') !== 'no_data' ? $t('no_data') : 'ไม่พบข้อมูล'"
      >
        <el-table
          :data="queriedData2"
          row-key="id"
          header-row-class-name="thead-light"
          @selection-change="selectionChange2"
        >

          <el-table-column :label="$t('lmg.customer')" min-width="200">
            <template slot-scope="{ row }">
              {{ row.CustomerFname }} {{ row.CustomerLname }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('lmg.policy_number')" min-width="200">
            <template slot-scope="{ row }">
              {{ row.PolicyNumber }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('lmg.protection_date')" min-width="200">
            <template slot-scope="{ row }">
              {{ row.StartDateShow }} - {{ row.EndDateShow }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('lmg.amount')" min-width="150">
            <template slot-scope="{ row }">
              <span v-if="row.MoreDiscount > 0" class="text-red">{{
                FormatCurrency(row.Amount)
              }}</span>
              <span v-else>{{ FormatCurrency(row.Amount) }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('lmg.discount')" min-width="150">
            <template slot-scope="{ row }">
              {{ FormatCurrency(row.CommissionAmount) }}
            </template>
          </el-table-column>
        </el-table>
      </calm-table>

      <div class="row" slot="footer">
        <div class="col wht__modal-actions">

          <calm-button
            variant="ghost"
            @click="showTransModal = false"
          >
            {{ $t("close") }}
          </calm-button>
        </div>
      </div>
    </modal>
  </calm-page>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import clientPaginationMixin2 from "./PaginatedTables/clientPaginationMixin2";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { TimeGrid } from "@fullcalendar/timegrid";

export default {
  mixins: [clientPaginationMixin, clientPaginationMixin2],
  components: {
    BasePagination,
    flatPicker,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      tableData: "Transaction/getWht",
      tablePersonWithAll: "Person/getDataWithAll",
      tableData2: "Transaction/getData",
      tablePerson: "Person/getData",
      isLoading: "Transaction/isLoading"
    }),

    paramsSearch: function() {
      if (
        this.params.owner_person_id != 0 ||
        this.params.book_id != "" ||
        this.params.number_id != ""
      ) {
        return {
          owner_person_id: this.params.owner_person_id,
          book_id: this.params.book_id,
          number_id: this.params.number_id,
          start_date: "",
          end_date: ""
        };
      }

      return this.params;
    },
    paramsSearchTransaction: function() {
      return {
        startDate: "",
        endDate: "",
        sort: 1, //1=DESC
        status: 1, // 0 all, 1 เสร็จ, 2 กำลังดำเนินงาน
        insuranceID: 0, // insureanid
        cashClear: 0, //  0 all, 1 ไม่มีเงินสดค้างที่พนักงาน, 2 มีเงินสดค้าง, 3 ไม่ใช่เงินสด ไม่มีเงินค้าง
        policyNumber: "",
        hasWhtFiles: 2,
        ownerPersonID: this.params.owner_person_id
      };
    },
    tableColumns: function() {
      return [
        {
          prop: "Name",
          label: this.$t("lmg.agent"),
          minWidth: 90,
          sortable: true
        },
        {
          prop: "AccountNumber",
          label: this.$t("lmg.bank_account"),
          minWidth: 100,
          sortable: true
        }
      ];
    },
    createParams: function() {
      return {
        transaction_id_list: this.selectedRows2.map(v => {
          return v.ID;
        }),
        policy_list: this.selectedRows2.map(v => {
          return v.PolicyNumber;
        }),
        owner_person_id: this.params.owner_person_id
      };
    }
  },
  data() {
    return {
      propsToSearch: ["Name", "AcountNumber"],
      propsToSearch2: ["Name", "AcountNumber"],
      selectedRows: [],
      selectedRows2: [],
      showAddModal: false,
      showTransModal: false,

      params: {
        owner_person_id: "",
        book_id: "",
        number_id: "",
        start_date: "",
        end_date: ""
      }
    };
  },
  mounted() {
	this.params.start_date = this.getStartDate();
    this.params.end_date = this.getEndDate();
    this.listPerson();
	this.clearTrans();
	this.clearWht();
  },
  methods: {
    ...mapActions({
      listData: "Transaction/listWht",
      listTransaction: "Transaction/listData",
      listPerson: "Person/listData",
      exportWht: "Transaction/exportWht",
      createData: "Transaction/createWht",
	  listWhtDetail :"Transaction/listWhtDetail",
	  clearTrans:"Transaction/clearTrans",
	  clearWht:"Transaction/clearWht",
    }),
    handleCreate() {
      this.showAddModal = true;

      if (this.tablePerson.length > 0) {
        this.params.owner_person_id = this.tablePerson[0].ID;
      }
	  this.clearTrans();
      this.SearchTransaction();
    },

    onCreate() {
      this.createData(this.createParams)
        .then(resp => {
          this.showAddModal = false;
          this.listData(this.paramsSearch);
          swal.fire({
            title: this.$t("create_success"),
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        })
        .catch(err => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteData({
              id: row.ID
            })
              .then(resp => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false
                });
              })
              .catch(err => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
              });
          }
        });
    },
    handleDetail(row) {
      let req = JSON.parse(row.req_json);
	  this.clearTrans()
      this.listWhtDetail({transaction_id_list:req.transaction_id_list});
      this.showTransModal = true;
    },
    handleExport(row) {
      this.exportWht({
        id: row.id
      })
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          console.log(err);
        });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    SearchTransaction() {
      this.selectedRows2 = [];
      this.listTransaction(this.paramsSearchTransaction);
    },
    selectionChange2(selectedRows) {
      this.selectedRows2 = selectedRows;
    }
  }
};
</script>
<style scoped>
/* WHT (withholding-tax) — Calm skin. Everything namespaced under .wht so no
   global leakage. The el-tables are kept verbatim (§11 "skin, don't rewrite")
   and re-styled only through deep selectors. <script> is untouched. */

/* Free-text search box in the table-head toolbar reuses the Kit's .ed look. */
.wht__search {
  width: 260px;
  max-width: 100%;
}

/* Filter-bar inputs/selects span their grid cell. */
.wht >>> .ed {
  width: 100%;
}

/* Commission amount: mono + tabular for clean column alignment (presentation). */
.wht__amount {
  font-variant-numeric: tabular-nums;
}

/* Row-action cell: keep the icon buttons inline + right-aligned. */
.wht__rowact {
  display: inline-flex;
  gap: 6px;
  justify-content: flex-end;
  width: 100%;
}

/* Modal footer action row: right-aligned, spaced buttons. */
.wht__modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

/* ── Skin the existing <el-table> as a Calm surface (deep selectors only). ── */
.wht >>> .el-table {
  color: var(--c-text, #2c3e50);
  background: transparent;
}
.wht >>> .el-table th,
.wht >>> .el-table .thead-light th {
  background: var(--c-surface-soft, #f4f7fb);
  color: var(--c-text-soft, #5b6b7e);
  font-weight: 600;
  border-bottom: 1px solid var(--c-border, #e3e9f0);
}
.wht >>> .el-table td {
  border-bottom: 1px solid var(--c-border, #eef2f7);
}
.wht >>> .el-table::before {
  background: var(--c-border, #e3e9f0);
}
.wht >>> .el-table__row:hover > td {
  background: var(--c-surface-soft, #f7fafd) !important;
}

/* The two modals render at <body> (outside .calm), so skin their el-tables
   globally-but-scoped via the modal-secondary wrapper used by both modals. */
.wht >>> .modal .el-table th,
.wht >>> .modal .el-table .thead-light th {
  background: var(--c-surface-soft, #f4f7fb);
  color: var(--c-text-soft, #5b6b7e);
}
</style>
